<template>
    <div style="display:block">
        订单号：<input v-model="orderNo" />
        <el-button type="primary" @click="redirectPayPage">生成支付</el-button>
        <!-- <div id="generalPayHtml" style="width:600px;height:300px;" v-html="queryPayHtml"> -->
        <!-- </div> -->
        <iframe style="width:600px;height:300px;">
            <html>
            <body>
                <div id="generalPayHtml" style="width:600px;height:300px;" v-html="queryPayHtml">
                </div>
            </body>
            </html>
        </iframe>


        <el-button type="primary" @click="queryPay">查询支付</el-button>
        <el-button type="primary" @click="prepayOrder">订单准备支付</el-button>

        <div id="orderPayHtml">
        </div>

        <div style="width:100px;height:300px;">
            <form name="punchout_form" method="post"
                action="https://openapi.alipay.com/gateway.do?charset=UTF-8&method=alipay.trade.page.pay&sign=m2CC4Sd7L%2BcfjDuOt2TSioQ4wHPtD0kb4mQeqxoxHXFJ1BeLb3j9KCWcFPNkAJkR5SsUwcj2aXbeXjmwVQ4Tb8TYIzz57oI1eyEHjebjfxuAeepWQlOW1rQO3iF3ECQx30KgR2dbW%2FHJul%2Bxw1R9ssoBDT80da6DuCwItV6sXO0zA%2BPTxVSgQfoOuug1iAODUYHx9J50L9lOupagM7QTEq5mW2erHSeG5F%2B0GR3PLJaqeUueQqUnzeI6yag2gpRaKfqEIZcHM5HBOKHxrvQ2OONafQNKhsuMuMCyQJN%2BqdmpOquj166GhEm2znLgEU%2Fsj6QYDCOdF46WiAVS2sTAAw%3D%3D&version=1.0&app_id=2021003189617677&sign_type=RSA2&timestamp=2023-05-03+20%3A54%3A41&alipay_sdk=alipay-sdk-java-4.35.107.ALL&format=json">
                <input type="hidden" name="biz_content"
                    value="{&quot;total_amount&quot;:0.01,&quot;subject&quot;:&quot;测试商品&quot;,&quot;product_code&quot;:&quot;FAST_INSTANT_TRADE_PAY&quot;}">
                <input type="submit" value="立即支付" style="display:none">
            </form>
        </div>

        <div ref="alipayWap" v-html="alipayHtml" />
    </div>
</template>
  
<script>
import { PayAPI } from '../../api/pay';
import { OrderAPI } from '../../api/order';

export default {
    name: 'Pay',
    data() {
        return {
            orderNo: "dev-2023050800120002",
            generalPayHtml: '',
            queryPayHtml: '',
            alipayHtml:''
        }
    },
    methods: {

        async generalPay() {
            PayAPI.generalPay(this.orderNo).then(res => {
                // document.getElementById("generalPayHtml").innerHTML = resp;
                // this.generalPayHtml = resp;
                // document.forms[0].submit() 
                //返回参数 

                // let routerData = this.$router.resolve({
                //     path: '/apply',
                //     query: { htmls: res }
                // });
                // this.htmls = res;

                //打开新页面 
                // window.open("routerData.href", '_blank');
                // const div = document.createElement('div');
                // div.innerHTML = res;
                // document.body.appendChild(div);
                // document.forms[0].submit();
                console.info(res)
                // this.queryPayHtml = res
                // document.forms[0].submit();
                // this.openNewTab(res)
                let iframeDocument = document.getElementsByTagName("iframe")[0].contentDocument;
                const div = iframeDocument.createElement('div');
                div.innerHTML = res;
                iframeDocument.body.appendChild(div);
                iframeDocument.forms[0].submit();
            })
        },

        redirectPayPage(){
            PayAPI.generalPay(this.orderNo).then(res => {
                // this.alipayHtml = res.pay_html
                this.openNewTab(res)
            })
        },

        queryPay() {
            PayAPI.queryPay(this.orderNo).then(resp => {
                document.getElementById("queryPayHtml").innerHTML = resp;
                // this.queryPayHtml = resp;
                document.forms[0].submit()
            })
        },

        prepayOrder() {
            OrderAPI.prepayOrder(this.orderNo).then(resp => {
                document.getElementById("orderPayHtml").innerHTML = resp;
                // this.queryPayHtml = resp;
                document.forms[0].submit()
            })
        },

        openNewTab(htmlText) {
            console.info(htmlText)
            // 创建一个新的窗口
            const newWindow = window.open();

            // 给新窗口设置HTML内容
            newWindow.document.write(`
                <html>
                <body>
                    ${htmlText}
                </body>
                </html>
            `);
        }


    },
    mounted() {
        // this.generalPay()
    }
}
</script>
  
  
  <!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>
  
  
  


// WEBPACK FOOTER //
// src/components/test/Pay.vue